import { all, put, takeLatest } from "redux-saga/effects";
import {
    GET_APPEARANCE_LOGOS,
    UPLOAD_APPEARANCE_LOGO,
    UPLOAD_APPEARANCE_LOGO_FAILURE,
    DELETE_APPEARANCE_LOGO,
} from "./constants";
import { requestLogos, requestLogoUpload, requestLogoDelete } from "./api";
import {
    getLogosSuccess,
    uploadLogoSuccess,
    uploadLogoFailure,
    deleteLogoSuccess,
} from "./actions";

/**
 *
 * @returns {IterableIterator<PutEffect<{logos: *}>>}
 */
function* getLogos() {
    const logos = yield requestLogos();
    if (logos) {
        yield put(getLogosSuccess(logos));
    }
}

/**
 *
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{response}>>}
 */
function* uploadLogo(actionObj) {
    try {
        const response = yield requestLogoUpload(actionObj.payload);
        if (response) {
            if (response.file) {
                yield put(uploadLogoFailure(response.file));
            } else {
                yield put(uploadLogoSuccess(response));
            }
        }
    } catch (error) {
        yield put({
            type: UPLOAD_APPEARANCE_LOGO_FAILURE,
            payload: error.message,
        });
    }
}

/**
 * Saga to handle logo deletion.
 * @param actionObj
 * @returns {IterableIterator<PutEffect<{id, type}>>}
 */
function* deleteLogo(actionObj) {
    const response = yield requestLogoDelete(actionObj.id);
    if (response) {
        yield put(deleteLogoSuccess(actionObj.id));
    }
}

/**
 *
 * @returns {IterableIterator<ForkEffect>}
 */
function* watchAppearanceLogo() {
    yield takeLatest(GET_APPEARANCE_LOGOS, getLogos);
    yield takeLatest(UPLOAD_APPEARANCE_LOGO, uploadLogo);
    yield takeLatest(DELETE_APPEARANCE_LOGO, deleteLogo);
}

function* appearanceLogoSaga() {
    yield all([watchAppearanceLogo()]);
}

export default appearanceLogoSaga;
